const clubPageStyles = {
  card: {
    margin: '24px',
  },
  clubHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '24px',
  },
  clubLogo: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    objectFit: 'cover',
  },
  clubName: {
    fontWeight: 'bold',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardTitle: {
    fontWeight: 'bold',
  },
  divider: {
    marginBottom: '16px',
  },
  tableContainer: {
    marginTop: '16px',
    maxHeight: 'calc(100vh - 380px)',
    overflow: 'auto',
  },
  clickableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  teamNameCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  teamLogo: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    objectFit: 'cover',
  },
  seasonChip: {
    margin: '2px 4px 2px 0',
  },
}

export default clubPageStyles
